import memoize from 'memoizee'

export const getExamScheduleForStudent = memoize((state, studentId) => {
  const { schedules } = state.studentsExamSchedules
  return schedules[studentId]
})

export const getExamScheduleStatusProps = state => {
  const { fetching, fetched, error } = state.studentsExamSchedules
  return { fetching, fetched, error }
}
